// libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import CardTag from './CardTag';

// Props and Context
const propTypes = {
  tags: PropTypes.array,
};

const defaultProps = {
  tags: [],
};

const contextTypes = {
  t: PropTypes.func,
};

function CardTags({ tags }) {
  return (
    <div className="card__tags">
      {tags
        .filter(tag => (tag.taxonomy !== 'school-level-category' || tag.visible))
        .map((tag) =>
          <CardTag
            key={`tag-${tag.taxonomy}-${tag.abbreviation}`}
            {...tag}
          />,
      )}
    </div>
  );
}

CardTags.contextTypes = contextTypes;
CardTags.defaultProps = defaultProps;
CardTags.propTypes = propTypes;

export default CardTags;



// WEBPACK FOOTER //
// ./src/app/components/cards/card/parts/cardTags/CardTags.js